module.exports = function() {
  return new Worker(__webpack_public_path__ + "7de5e0a92c1a96ac2b6f.worker.js");
};